export default "__VITE_ASSET__30c28a80__"